import { domIdentitiesReverseIterator } from "./iterators.js";
function drawDOMIdentitySvg(params) {
  const { renderer, identities, identityToStroke } = params;
  renderer.textContent = "";
  for (const element of domIdentitiesReverseIterator(identities)) {
    if (element.parentIndex === -1) continue;
    const width = element.right - element.left;
    const height = element.bottom - element.top;
    if (width < 0 || height < 0) {
      continue;
    }
    const svgRect = globalThis.document.createElementNS("http://www.w3.org/2000/svg", "rect");
    svgRect.setAttribute("x", element.left.toString());
    svgRect.setAttribute("y", element.top.toString());
    svgRect.setAttribute("width", width.toString());
    svgRect.setAttribute("height", height.toString());
    svgRect.setAttribute("opacity", "1");
    svgRect.setAttribute("fill", "none");
    svgRect.setAttribute("stroke-width", "1");
    svgRect.setAttribute("stroke", identityToStroke(element.identity));
    renderer.appendChild(svgRect);
  }
  return renderer;
}
export {
  drawDOMIdentitySvg
};
//# sourceMappingURL=drawDOMIdentitySvg.js.map
